<template>
  <div style="padding-left: 10px;padding-right: 10px;min-width: 200px;max-width: 300px;max-height: 250px;overflow: auto">
    <div class="col-xs-12">
      <span class="">Filter by new documents</span>
    </div><div class="col-xs-12" style="margin-top: 5px">
    <div class="row">
      <div class="col-xs-6">
        <a role="button" class="text-info"
           style="font-size: 12px;font-weight: normal;font-style: italic;" @click="feedFilter"> Select All</a>
      </div>
      <div class="col-xs-6 text-right">
        <a role="button" class="text-info"
           style="font-size: 12px;font-weight: normal;font-style: italic;" @click="clearFilter"> Clear All</a>
      </div>
    </div>
  </div>
    <div class="col-xs-12" style="margin-top: 5px">
      <div v-for="(newDocument, key) in newDocuments" v-if="newDocument"  :key="key" style="padding-top: 10px">
        <div class="checkbox checkbox-info checkbox-inline">
          <input :id="uniqId + 'checkbox-newDocuments-' + newDocument.name" type="checkbox" v-on:change="selected(newDocument)"
                 v-bind:checked="checked(newDocument)">
          <label :for="uniqId + 'checkbox-newDocuments-' + newDocument.name">
            <template v-if="newDocument.name === true"> New</template>
            <template v-else> Old</template>
            <span class="filter-year-item-nb">({{newDocument.nb}})</span></label>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
  .pe-ul > li {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 10px;
  }

  .pe-ul > li > i{
    color: #62cb31;
    font-weight: bold;
  }

  .pe-ul > li > span{
    font-size: 14px;
    font-weight: normal;
  }

</style>
<script>

export default {
  components: {},
  props: ['newDocuments', 'newDocumentsSelected'],
  name: 'NewDocumentsBox',
  data () {
    return {
      uniqId: ''
    }
  },
  methods: {
    checked: function (newDocument) {
      if (this.newDocumentsSelected.length !== 0) {
        let tmp = this.newDocumentsSelected.find((element) => {
          return newDocument.name === element.name
        })
        if (typeof tmp !== 'undefined') {
          return true
        }
      }
      return false
    },
    selected: function (newDocument) {
      let index = this.newDocumentsSelected.map((e) => {
        return e.name
      }).indexOf(newDocument.name)

      if (index === -1) {
        this.newDocumentsSelected.push(newDocument)
      } else {
        this.newDocumentsSelected.splice(index, 1)
      }
    },
    clearFilter: function (event) {
      this.newDocumentsSelected.splice(0, this.newDocumentsSelected.length)
      event.preventDefault()
    },
    feedFilter: function (event) {
      this.clearFilter(event)

      this.newDocuments.forEach((year) => {
        this.newDocumentsSelected.push(year)
      })
      event.preventDefault()
    }
  },
  beforeMount () {
    this.uniqId = Math.random().toString()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/filter/NewDocumentsBox.vue